import { forwardRef, useCallback, useMemo, useRef } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useSyncRefs } from '~/hooks'
import { isTouchSupported } from '~/utils'
// import PerfectScrollbar from './PerfectScrollbar'
import { ScrollContext } from '.'

const Native = forwardRef((props, ref) => {
  const {
    children,
    className,
    disabled,
    options: { suppressScrollX = false, suppressScrollY = false } = {},
    style,
    onYReachEnd,
    ...rest
  } = props
  const onScroll = (e) => {
    if (rest.onScroll) rest.onScroll(e)
    const element = e.target
    if (
      onYReachEnd &&
      element.scrollHeight - element.offsetHeight === element.scrollTop
    ) {
      onYReachEnd()
    }
  }

  if (style) {
    delete style.overflow
  }

  return (
    <div
      ref={ref}
      className={clsx(
        'scrollbar-container',
        className,
        !disabled &&
          clsx(
            suppressScrollX ? 'overflow-x-hidden' : 'overflow-x-auto',
            suppressScrollY ? 'overflow-y-hidden' : 'overflow-y-auto'
          )
      )}
      style={style}
      onScroll={onScroll}
    >
      {children}
    </div>
  )
})

Native.displayName = 'Native'

Native.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.shape({
    suppressScrollX: PropTypes.bool,
    suppressScrollY: PropTypes.bool,
  }),
  style: PropTypes.object,
  onScroll: PropTypes.func,
  onYReachEnd: PropTypes.func,
}

const Scrollbar = forwardRef((props, ref) => {
  const { disabled, native: nativeProp, ...rest } = props

  const native = useMemo(() => nativeProp || true, [nativeProp])
  // console.log('Scrollbar -> props', props)

  const internalRef = useRef()
  const syncedRefs = useSyncRefs(internalRef, ref)

  const update = useCallback(
    () => internalRef.current?.updateScroll(),
    [internalRef]
  )

  return (
    <ScrollContext.Provider value={{ update }}>
      {disabled ? (
        <div className={rest.className}>{rest.children}</div>
      ) : native || isTouchSupported() ? (
        <Native ref={props.containerRef} {...rest} />
      ) : (
        <PerfectScrollbar ref={syncedRefs} {...rest} />
      )}
    </ScrollContext.Provider>
  )
})

Scrollbar.displayName = 'Scrollbar'

Scrollbar.propTypes = {
  className: PropTypes.string,
  containerRef: PropTypes.any,
  disabled: PropTypes.bool,
  native: PropTypes.bool,
  options: PropTypes.shape({
    suppressScrollX: PropTypes.bool,
    suppressScrollY: PropTypes.bool,
  }),
  onScroll: PropTypes.func,
}

export default Scrollbar
